import React from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from 'react-redux';
import { Alert, Card, Layout } from 'antd';
import WhiteLabel from '../WhiteLabel';
import { isWhiteLabelAllowed } from '../../store/sales/selectors';
import LoadingIndicator from '../../components/shared/LoadingIndicator/LoadingIndicator';


const { Content } = Layout;


export default function WhiteLabelPage() {
    const navigate = useNavigate();
    const { id } = useParams();
    const allowWhiteLabel = useSelector((state) => isWhiteLabelAllowed(state));

    return (
        <Content className="general-layout-content">
            <Card className="white-label-tabs">
                {allowWhiteLabel === null && <LoadingIndicator />}

                {allowWhiteLabel === false && (
                    <Alert
                        message="This feature is disabled for your current plan!"
                        description={
                            <>
                                In order to use this feature, you must{' '}
                                <span
                                    className="fake-link"
                                    onClick={() => navigate('/subscription/plans')}
                                    style={{ color: '#fe6100' }}
                                >
                                    upgrade
                                </span>{' '}
                                your plan.
                            </>
                        }
                        type="warning"
                        showIcon
                    />
                )}

                {allowWhiteLabel === true && <WhiteLabel templateGuid={id} />}
            </Card>
        </Content>
    );
}
